import { Empty } from 'antd'

export const presentedEmptyImage = {
  SIMPLE: Empty.PRESENTED_IMAGE_SIMPLE,
  DEFAULT: Empty.PRESENTED_IMAGE_DEFAULT
}
